// extracted by mini-css-extract-plugin
export default {"loading-spinner":"_3JD7X","loadingSpinner":"_3JD7X","core-icon":"_3ggRP","coreIcon":"_3ggRP"};